import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Maintenance images
import acImage from '../assets/images/services/maintenance/Ac .jpg';
import sAfterSImage from '../assets/images/services/maintenance/S after S.jpg';

// Import Maintenance video
import maintenanceVideo from '../assets/videos/services/Maintenance.mp4';

// Import Maintenance benefits image
import maintenanceBenefitsImage from '../assets/images/services/maintenance/CCTV AND ACCESS CONTROL MAINTENANCE.jpg';

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Maintenance Services" description="Reliable maintenance services in DRC: CCTV maintenance, AC maintenance, preventive maintenance contracts by Cool & Care." keywords="maintenance services DRC, CCTV maintenance, AC maintenance, preventive maintenance Kinshasa" />
      <ServiceSchema name="Maintenance Services" description="Reliable maintenance services including CCTV, AC, and preventive maintenance contracts." url="/maintenance" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Maintenance', url: '/maintenance' }]} />
      <ServicePage
        serviceName={t('servicePage.services.maintenance.name')}
      serviceDescription={t('servicePage.services.maintenance.description')}
      videoUrl={maintenanceVideo}
      productImages={[
        acImage,
        sAfterSImage
      ]}
      features={t('servicePage.services.maintenance.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.maintenance.benefits', { returnObjects: true }) as string[]}
      benefitsImage={maintenanceBenefitsImage}
    />
    </>
  );
};

export default MaintenancePage;
